export const getActiveValue = (obj) => {
    const string = typeof obj === 'string' ? obj : '-';
    return obj?.thesaurus?.[localStorage.getItem('activeLanguage')] || obj?.value || string;
};
